export const packageList = [
  {
    name: 'vms',
    activeRule: ['vcar', 'vms', 'vms-safe', 'vms-general', 'vms-report', 'vms-overview', 'vms-oil', 'vms-insurance', 'vms-traffic', 'vms-accident', 'vms-oa', 'vms-assets', 'vms-electricity', 'vms-monitor', 'v-auto-parts', 'vms-supplier-site', 'vms-maintenance', 'vms-subsidy', 'vms-toll', 'vms-instration', 'vms-service', 'vms-car', 'vms-kpi', 'vms-efficiency', 'vms-appearance', 'vms-equipment', 'vms-vehmaint-realtime', 'vms-reconciliation-management', 'vms-real-time-volume-vehicle'],
    // preload: true,
  },
]

export const remoteModuleConfig = {
  dev: ['vms'],
  stg: ['vms'],
  uat: ['vms'],
  prd: ['vms'],
}



// WEBPACK FOOTER //
// ./src/layout/router/remote/package-list/vms/index.js